import {FETCH_PROGRESS_REPORT} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_PROGRESS_REPORT:
            return action.payload;
        default:
            return state;
    }
};